var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100vh"}},[_vm._v(" Wait until we are verifying you... ")])}
var staticRenderFns = []

export { render, staticRenderFns }